/* eslint-disable jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import FileUploadInitial from '../../icons/FileUploadInitial';

import styles from '../FileUploader.module.scss';

const cx = classNames.bind(styles);

const Initial = ({ title, onChangeFile, className, dataTest = '' }) => {
  const fileUploaderClasses = cx(styles['file-uploader'], className);
  const isExperiment =
    useSoyuzExperiment('MainCTAsLookAndFeel').get('behaviour') === 'variant';

  const uploadBtnClasses = cx(styles['file-uploader__button'], {
    [styles['file-uploader__button--rebranding']]: isExperiment
  });

  return (
    <div
      data-cy="fileUploaderInitialState"
      className={fileUploaderClasses}
      data-test={dataTest}
    >
      <div className={styles['file-uploader__content']}>
        <div>
          <FileUploadInitial className={styles['file-uploader__icon']} />
        </div>
        <div className={styles['file-uploader__title']}>{title}</div>
      </div>

      <label data-cy="fileUploaderUpload" className={uploadBtnClasses}>
        <input
          data-cy="fileUploaderInput"
          onChange={onChangeFile}
          type="file"
          className={styles['file-uploader__input-file--is-hidden']}
        />
        {trans('document-upload.browse')}
      </label>
    </div>
  );
};

Initial.propTypes = {
  title: PropTypes.string.isRequired,
  onChangeFile: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  dataTest: PropTypes.string
};

export default Initial;
